import { SVG_ENUM } from "enums";
import SVG from "shared/SVG";
import "./BackButton.scss";

interface BackButtonProps {
  onClick: () => void;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  className = "",
}) => {
  return (
    <div className={`back-button ${className}`} onClick={onClick}>
      <span className="back-button__icon">
        <SVG type={SVG_ENUM.ARROW_BACK} />
      </span>
      Wróć
    </div>
  );
};

export default BackButton;
